import React from 'react';

import {
  Box,
  Card,
  Chip,
  Stack,
  Divider,
  Container,
  Button,
  Typography,
} from '@mui/material';
import { useNavigate} from 'react-router-dom';

import Iconify from 'src/components/iconify';

import { APP_VERSION } from 'src/components/AppVersion';

export default function ReleaseNotesPage() {
  const navigate = useNavigate();
  const features = [
    {
      title: 'Talent Acquisition Module',
      description: 'Manage requisitions and recruitment workflows.',
    },
    {
      title: 'Human Resources Management',
      description: 'Centralized employee and HR operations.',
    },
    {
      title: 'Approval Workflow System',
      description: 'Multi-level approval process handling.',
    },
    {
      title: 'Project & Client Management',
      description: 'Manage projects and associated clients efficiently.',
    },
    {
      title: 'User & Role Management',
      description: 'Role-based access and permission control.',
    },
    {
      title: 'Help & Support Center',
      description: 'Integrated support and guidance system.',
    },
    
  ];

  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Card
        sx={{
          p: 4,
          borderRadius: 3,
          boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
        }}
      >
        <Stack spacing={3}>
          {/* Header */}
          <Box>
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              justifyContent="space-between"
              flexWrap="wrap"
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Typography variant="h4" fontWeight={700}>
                  {APP_VERSION}
                </Typography>

                <Chip label="Initial Release" color="success" size="small" />
              </Stack>

              <Button
                onClick={() => navigate('/')}
                startIcon={<Iconify icon="eva:home-fill" width={18} />}
                variant="contained"
                size="small"
                sx={{
                  fontWeight: 700,
                  px: 1.5,
                  py: 0.6,
                  borderRadius: 2,
                  color: 'common.white',
                  bgcolor: 'success.main',
                  boxShadow: '0 8px 20px rgba(16,185,129,0.18)',
                  textTransform: 'none',
                  '&:hover': {
                    bgcolor: 'success.dark',
                    transform: 'translateY(-1px)',
                  },
                }}
              >
                Back to Home
              </Button>
            </Stack>

            <Typography
              variant="body2"
              sx={{
                mt: 1,
                color: 'text.secondary',
              }}
            >
              Released on April 2026
            </Typography>
          </Box>

          <Divider />

          {/* Description */}
          <Box>
            <Typography variant="body1">
              Welcome to the first official release of MeruDesk —
              a centralized enterprise platform designed to streamline
              HR operations, approvals, requisitions, and organizational workflows.
            </Typography>
          </Box>

          <Divider />

          {/* Features */}
          <Box>
            <Typography variant="h6" fontWeight={700}>
              Included Features
            </Typography>

            <Stack spacing={1.5} sx={{ mt: 2 }}>
              {features.map((item) => (
                <Box
                  key={item.title}
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    bgcolor: 'background.neutral',
                    border: (theme) =>
                      `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <Stack
                    direction="row"
                    spacing={1.2}
                    alignItems="flex-start"
                  >
                    <Iconify
                      icon="solar:check-circle-bold"
                      width={20}
                      sx={{
                        color: 'success.main',
                        mt: 0.2,
                      }}
                    />

                    <Box>
                      <Typography
                        variant="subtitle2"
                        fontWeight={700}
                      >
                        {item.title}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          mt: 0.5,
                          color: 'text.secondary',
                        }}
                      >
                        {item.description}
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              ))}
            </Stack>
          </Box>

          <Divider />

          {/* Coming Soon */}
          <Box>
            <Typography variant="h6" fontWeight={700}>
              Coming Soon
            </Typography>

            <Stack spacing={1.2} sx={{ mt: 2 }}>
              {[
                'Notification System'
              ].map((feature) => (
                <Stack
                  key={feature}
                  direction="row"
                  spacing={1.2}
                  alignItems="center"
                >
                  <Iconify
                    icon="solar:clock-circle-bold"
                    width={18}
                    sx={{ color: 'warning.main' }}
                  />

                  <Typography variant="body2">
                    {feature}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Box>
        </Stack>
      </Card>
    </Container>
  );
}